import styles from './Legal.module.css';
import { SectionWrapper } from '../components/shared/SectionWrapper';
import { useSEO } from '../hooks/useSEO';

export function Privacy() {
  useSEO({
    title: 'Privacy Policy',
    description: 'LuvLust Privacy Policy. Learn how we collect, use, and protect your information.',
    keywords: 'luvlust privacy policy, data protection, couples app privacy',
  });

  return (
    <SectionWrapper>
      <article className={styles.legal}>
        <h1 className={`display ${styles.title}`}>Privacy Policy</h1>
        <p className={styles.date}>Effective Date: January 01, 2024</p>
        <p>Welcome to LuvLust ("App"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our App. If you do not agree with the terms of this Privacy Policy, we request you not use the App.</p>

        <h2>1. Information We Collect</h2>
        <h3>a. Personal Information</h3>
        <p>We do not collect personally identifiable information unless explicitly provided by you (e.g., when contacting us for support).</p>
        <h3>b. Non-Personal Information</h3>
        <p>We may collect non-personal information, such as device type, operating system, and usage statistics, to improve the App's performance and user experience.</p>

        <h2>2. How We Use Your Information</h2>
        <p>We use the collected information to:</p>
        <ul>
          <li>Improve and personalize the App</li>
          <li>Monitor and analyze trends and usage</li>
          <li>Fix bugs and enhance security</li>
          <li>Respond to support requests</li>
        </ul>

        <h2>3. Third-Party Services</h2>
        <p>Our App may use third-party services such as analytics providers and advertising networks. These services may collect information based on your interactions with the App. We encourage you to review their respective privacy policies.</p>

        <h2>4. Data Retention</h2>
        <p>We retain collected data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy. Non-personal information may be retained indefinitely for analytics and performance monitoring.</p>

        <h2>5. Security</h2>
        <p>We take reasonable measures to protect your information from unauthorized access, alteration, or disclosure.</p>

        <h2>6. Children's Privacy</h2>
        <p>Our App is not intended for children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us. If you are under the age of 13, please do not use the app.</p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted within the App. Your continued use of the App after such changes constitutes your acceptance of the updated policy.</p>

        <h2>8. Contact Us</h2>
        <p>If you have any questions or concerns regarding this Privacy Policy, please contact us at:</p>
        <p><a href="mailto:starlitapps.dev@gmail.com">starlitapps.dev@gmail.com</a></p>

        <p className={styles.consent}>By using LuvLust, you consent to this Privacy Policy.</p>
      </article>
    </SectionWrapper>
  );
}
